import { consolidationOrg, eliminationOrg } from './compute/special-entities.js'
import { defaultCurrencySymbol } from './load/target-currency-symbol.js'

export function setNeededData (context, optionSelectorData = {}) {
  // Selected entity: optionSelectorData.organisationId
  // Which is actually an Array

  // Selected Consolidation
  console.log('setNeededData', optionSelectorData.organisationId)
  if (optionSelectorData.organisationId?.[0] === consolidationOrg.id) {
    context.includedEntityIds = context.browserAppAccount.data.entities?.map(e => e.id)
    context.includedEntityIds.push(eliminationOrg.id)

    // Or direct `conso-${context.accountData._id}`

    // To be reviewed
    // const xeroOrgIdsAvailable = context.accountData.organisations?.map(o => o.orgXeroId)

    // const organisations = []
    // context.entities?.forEach(function (entity) {
    //   if (xeroOrgIdsAvailable.includes(entity.xero_id)) organisations.push(entity)
    // // return entity
    // })

    // // context.includedEntityIds = [...context.entities.map(e => e.id)]
    // context.includedEntityIds = [...organisations.map(e => e.id)]
  } else {
    context.includedEntityIds = [...optionSelectorData.organisationId]
    if (context.includedEntityIds?.length > 1) {
      context.includedEntityIds.push(eliminationOrg.id)
    }
  }

  // Set the showingEntitiesIds: 1 (either entity or consolidation), or detailed each entity
  console.log('set showingEntitiesIds: optionSelectorData.entitiesLayout', optionSelectorData.entitiesLayout)
  context.entitiesLayout = optionSelectorData.entitiesLayout || 'consolidated'
  if (context.entitiesLayout === 'consolidated') {
    if (context.includedEntityIds.length > 1) {
      console.log('set showingEntitiesIds: consolidationOrg.id', consolidationOrg.id)
      context.showingEntitiesIds = [consolidationOrg.id]
    } else {
      console.log('set showingEntitiesIds: context.includedEntityIds', context.includedEntityIds)
      context.showingEntitiesIds = [...context.includedEntityIds]
    }
  } else {
    console.log('set showingEntitiesIds: context.includedEntityIds', context.includedEntityIds)
    context.showingEntitiesIds = [...context.includedEntityIds]

    if (context.includedEntityIds?.length > 1) {
      // context.showingEntitiesIds.push(eliminationOrg.id) // No need to add: already in includedEntityIds
      context.showingEntitiesIds.push(consolidationOrg.id)
    }
  }
  console.log(['showingEntitiesIds', context.showingEntitiesIds, 'includedEntityIds', context.includedEntityIds])

  // Set common currency
  context.currencySymbol = optionSelectorData.currencySymbol || 'XXX'

  if (context.includedEntityIds.length > 1 && context.currencySymbol === 'XXX') {
    const defaultCurrency = context.browserAppAccount.data.currenciesForAccount.find(c => c.is_default === true)
    let defaultCurrencyCode = defaultCurrency?.code

    if (!defaultCurrencyCode || defaultCurrencyCode === 'XXX') {
      defaultCurrencyCode = defaultCurrencySymbol(context)
    }
    context.currencySymbol = defaultCurrencyCode
    optionSelectorData.currencySymbol = defaultCurrencyCode
  }
}
